import { create } from "zustand";
import answers from "../data/answers";
const useAnswersStore = create((set) => ({
  answer: {
    vi: "",
    en: "",
  },

  getRandomAnswer: () => {
    const randomIndex = Math.floor(Math.random() * answers.length);
    set({
      answer: answers[randomIndex]
    })
  },
}))

export default useAnswersStore;
